<template>
  <div></div>
</template>

<script>
export default {
  name: "BindUser.vue"
}
</script>

<style scoped>

</style>